import { createRoutesFromElements, Route } from "react-router-dom";
import Login from "views/Login";
import Splash from "views/Splash";
import DatasetViewer from "views/DatasetViewer";
import DatasetDetail from "views/DatasetViewer/DatasetDetail/DatasetDetail";
import ProtectedRoute from "components/ProtectedRoute";

const routes = createRoutesFromElements(
  <>
    <Route path="/login" element={<Login />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/" element={<Splash />} />
      <Route path="/datasets" element={<DatasetViewer />} />
      <Route
        path="/datasets/defect/:datasetId"
        element={<DatasetDetail kind="defect" />}
      >
        <Route path=":imageId" />
      </Route>
      <Route path="/datasets/:datasetId" element={<DatasetDetail />}>
        <Route path=":imageId" />
      </Route>
    </Route>
  </>
);

export default routes;
